
{
  "familyId": "GET-VERH-BREUK-PROC-KOPPEL",
  "questions": [
    {
      "id": "GET-VERH-BREUK-PROC-KOPPEL-001",
      "familyId": "GET-VERH-BREUK-PROC-KOPPEL",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "procenten",
      "subSkill": "verh_breuk_proc_koppeling",
      "questionType": "multiple_choice",
      "question": "Welk percentage hoort bij de breuk ¾?",
      "options": [
        "75%",
        "34%",
        "50%",
        "80%"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_naar_procent",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Strategie: maak de noemer 100 of deel teller door noemer. Stap 1: ¾ = 3 ÷ 4 = 0,75. Stap 2: 0,75 × 100% = 75%. Of: ¾ × 25/25 = 75/100 = 75%.",
        "distractorExplanations": {
          "0": "Goed! ¾ = 75%. Je deelt 3 door 4 = 0,75 = 75%.",
          "1": "Veelgemaakte fout: teller en noemer naast elkaar schrijven. ¾ is niet 34%, maar 3 ÷ 4 = 0,75 = 75%.",
          "2": "Veelgemaakte fout: ½ en ¾ verwarren. ½ = 50%, maar ¾ = 75%.",
          "3": "Veelgemaakte fout: ⅘ en ¾ verwarren. ⅘ = 80%, maar ¾ = 75%."
        }
      }
    },
    {
      "id": "GET-VERH-BREUK-PROC-KOPPEL-002",
      "familyId": "GET-VERH-BREUK-PROC-KOPPEL",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "procenten",
      "subSkill": "verh_breuk_proc_koppeling",
      "questionType": "multiple_choice",
      "question": "Schrijf 0,4 als breuk in de eenvoudigste vorm.",
      "options": [
        "⅖",
        "4/10",
        "¼",
        "⅘"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "decimaal_naar_breuk",
      "variantIndex": 2,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Strategie: schrijf als breuk met noemer 10 en vereenvoudig. Stap 1: 0,4 = 4/10. Stap 2: Vereenvoudig: 4/10 ÷ 2/2 = 2/5 = ⅖.",
        "distractorExplanations": {
          "0": "Goed! 0,4 = 4/10 = ⅖ (gedeeld door 2).",
          "1": "Bijna goed! 4/10 is correct maar niet vereenvoudigd. Deel teller en noemer door 2: ⅖.",
          "2": "Veelgemaakte fout: ¼ = 0,25, niet 0,4. 0,4 = ⅖.",
          "3": "Veelgemaakte fout: ⅘ = 0,8, niet 0,4. 0,4 = ⅖."
        }
      }
    },
    {
      "id": "GET-VERH-BREUK-PROC-KOPPEL-003",
      "familyId": "GET-VERH-BREUK-PROC-KOPPEL",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "procenten",
      "subSkill": "verh_breuk_proc_koppeling",
      "questionType": "multiple_choice",
      "question": "Welk kommagetal hoort bij 20%?",
      "options": [
        "0,2",
        "0,02",
        "2,0",
        "0,20"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "procent_naar_decimaal",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Strategie: deel het percentage door 100. Stap 1: 20% = 20 ÷ 100 = 0,20 = 0,2.",
        "distractorExplanations": {
          "0": "Goed! 20% = 20 ÷ 100 = 0,2.",
          "1": "Veelgemaakte fout: te veel door 10 delen. 20 ÷ 1000 = 0,02. Maar procent = per honderd, dus ÷ 100.",
          "2": "Veelgemaakte fout: de komma verkeerd plaatsen. 20% = 0,2, niet 2,0.",
          "3": "Dit is wiskundig gelijk aan 0,2! 0,20 = 0,2. Beide zijn correct."
        }
      }
    },
    {
      "id": "GET-VERH-BREUK-PROC-KOPPEL-004",
      "familyId": "GET-VERH-BREUK-PROC-KOPPEL",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "procenten",
      "subSkill": "verh_breuk_proc_koppeling",
      "questionType": "multiple_choice",
      "question": "Welke drie horen bij elkaar? ⅕ = ... = ...%",
      "options": [
        "⅕ = 0,2 = 20%",
        "⅕ = 0,5 = 50%",
        "⅕ = 0,15 = 15%",
        "⅕ = 0,2 = 2%"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "drieledige_koppeling",
      "variantIndex": 4,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Strategie: reken de breuk om naar decimaal en procent. Stap 1: ⅕ = 1 ÷ 5 = 0,2. Stap 2: 0,2 × 100% = 20%. Stap 3: ⅕ = 0,2 = 20%.",
        "distractorExplanations": {
          "0": "Goed! ⅕ = 0,2 = 20%. De drieledige koppeling klopt.",
          "1": "Veelgemaakte fout: ½ en ⅕ verwarren. ½ = 0,5 = 50%, maar ⅕ = 0,2 = 20%.",
          "2": "Veelgemaakte fout: 1 en 5 samenvoegen. ⅕ ≠ 0,15. Deel: 1 ÷ 5 = 0,2.",
          "3": "Veelgemaakte fout: 0,2 als 2% lezen. 0,2 = 20% (× 100), niet 2%."
        }
      }
    },
    {
      "id": "GET-VERH-BREUK-PROC-KOPPEL-005",
      "familyId": "GET-VERH-BREUK-PROC-KOPPEL",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "procenten",
      "subSkill": "verh_breuk_proc_koppeling",
      "questionType": "multiple_choice",
      "question": "Zet 0,125 om in een breuk (eenvoudigste vorm).",
      "options": [
        "⅛",
        "1/125",
        "125/1000",
        "⅕"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "decimaal_naar_breuk_complex",
      "variantIndex": 5,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Strategie: schrijf als breuk met noemer 1000 en vereenvoudig. Stap 1: 0,125 = 125/1000. Stap 2: Deel door 125: 125/1000 = 1/8 = ⅛.",
        "distractorExplanations": {
          "0": "Goed! 0,125 = 125/1000 = ⅛.",
          "1": "Veelgemaakte fout: de decimalen als noemer gebruiken. 0,125 ≠ 1/125. Het is 125/1000 = ⅛.",
          "2": "Bijna goed! 125/1000 is correct maar niet vereenvoudigd. Deel door 125: ⅛.",
          "3": "Veelgemaakte fout: ⅕ = 0,2, niet 0,125. 0,125 = ⅛."
        }
      }
    }
  ]
}
